import { Icon } from '@assembly-js/design-system';
import React from 'react';

import {
  FILE_ACTION_DISABLE_TOOLTIP_LABEL,
  NEW_FILE_OPTIONS_FOR_MAIN,
} from 'src/constants';
import { useAppSelector } from 'src/hooks/useStore';
import { selectFileActionSettings } from 'src/store/files/selectors';

export const useFileChannelActionButton = () => {
  const { disableAddFile, disableFolderCreate } = useAppSelector(
    selectFileActionSettings,
  );

  const headerOptions = React.useMemo(() => {
    return [
      {
        label: NEW_FILE_OPTIONS_FOR_MAIN.NEW_FOLDER,
        icon: <Icon icon="Plus" className="w-3 h-3" />,
        disabled: disableFolderCreate,
        tooltip: FILE_ACTION_DISABLE_TOOLTIP_LABEL,
      },
    ];
  }, [disableFolderCreate]);

  const mainOptions = React.useMemo(() => {
    return [
      {
        label: NEW_FILE_OPTIONS_FOR_MAIN.UPLOAD_FILE,
        icon: <Icon icon="Upload" className="w-3 h-3" />,
        disabled: disableAddFile,
        tooltip: FILE_ACTION_DISABLE_TOOLTIP_LABEL,
      },
      {
        label: NEW_FILE_OPTIONS_FOR_MAIN.UPLOAD_FOLDER,
        icon: <Icon icon="Files" className="w-3 h-3" />,
        disabled: disableAddFile,
        tooltip: FILE_ACTION_DISABLE_TOOLTIP_LABEL,
      },
      {
        label: NEW_FILE_OPTIONS_FOR_MAIN.ADD_LINK,
        icon: <Icon icon="Link" className="w-3 h-3" />,
        disabled: disableAddFile,
        tooltip: FILE_ACTION_DISABLE_TOOLTIP_LABEL,
      },
    ];
  }, [disableAddFile]);

  return { headerOptions, mainOptions };
};
